import { render, staticRenderFns } from "./ButtonWithSpinner.vue?vue&type=template&id=64de97c6"
import script from "./ButtonWithSpinner.vue?vue&type=script&lang=js"
export * from "./ButtonWithSpinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports